import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {apolloClientProvider} from 'src/app/core/apollo/apollo-client.provider';
import {ApiService} from 'src/app/shared/modules/api/services/api.service';
import {CleanApiCacheGuard} from 'src/app/shared/modules/api/guards/clean-api-cache-guard.service';
import {HttpClientModule} from '@angular/common/http';
import {Apollo} from 'apollo-angular';

@NgModule({
    imports: [CommonModule, HttpClientModule],
    declarations: [],
    providers: [apolloClientProvider, ApiService, CleanApiCacheGuard, Apollo],
})
export class ApiModule {}
